import React, { useState, useEffect, useCallback } from 'react';
import { useParams, generatePath } from 'react-router';
import { useHistory } from 'react-router-dom';
import axios from 'axios';
import constClass from '../../Constants/Constants';
import { useToasts } from 'react-toast-notifications';
import moment from 'moment';
import Select from 'react-select';
import InfiniteScroll from "react-infinite-scroller";
import Modal from 'react-modal';
import DatePicker, { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import ja from 'date-fns/locale/ja';
import UseAlertModal from '../Common/UseAlertModal';
import Common from '../Common/common';
registerLocale('ja', ja);

const pageCount = 100;
const PointHistory = (props) => {
  const { siteId, cardId } = useParams();
  const { user, setting } = props;
  const [condition, setCondition] = useState({ card_id: null, shop: null, searchdate_start: null, searchdate_end: null });
  const [sectionCondition, setSectionCondition] = useState({ point_type: null });
  const [lockData, setLockData] = useState(false);
  const [shopMaster, setShopMaster] = useState(null);
  const [historySearch, setHistorySearch] = useState(false);
  const [historyData, setHistoryData] = useState(null);
  const [historyDataCount, setHistoryDataCount] = useState(0);
  const [totalPointsAwarded, setTotalPointsAwarded] = useState(0);
  const [totalPointsMallAwarded, setTotalPointsMallAwarded] = useState(0);
  const [totalPointsShopAwarded, setTotalPointsShopAwarded] = useState(0);
  const [pointsMallUsed, setPointsMallUsed] = useState(0);
  const [pointsShopUsed, setPointsShopUsed] = useState(0);
  const [pointsUsed, setPointsUsed] = useState(0);
  const [cancelData, setCancelData] = useState(null);
  const [invalidCause, setInvalidCause] = useState({ value: constClass.INVALID_CAUSE.RETURNED, label: constClass.INVALID_CAUSE_NAME.RETURNED });
  const [page, setPage] = useState(0);
  const [modalFlag, setModalFlag] = useState(false);
  const { addToast } = useToasts();
  const [isAlertModalOpen, setIsAlertModalOpen] = useState(false);
  const [alertModalMessage, setAlertModalMessage] = useState('');
  const history = useHistory();
  const modalStyle = {
    overlay: {
      position: "fixed",
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      backgroundColor: "rgba(0,0,0,0.5)",
      zIndex: 1000
    },
    content: {
      position: "absolute",
      left: '0.5rem',
      right: '0.5rem',
      top: '10vw',
      bottom: 'auto',
      marginTop: '0.5rem',
      borderRadius: "0rem",
      padding: "0px",
      height: "auto",
      zIndex: 1000
    }
  };
  const refreshMaster = useCallback(async () => {
    var con = { card_id: cardId, searchdate_start: new Date(), searchdate_end: new Date(), invalid_flag: constClass.FLAG.OFF, shop: null };
    if (setting) {
      setLockData(true);
      const jwt = localStorage.getItem('jwt');

      const shopData = (await axios.get(`${process.env.REACT_APP_BACKEND_URL}/shop/${siteId}/${user.mallId}`, {
        headers: {
          Authorization: `Bearer ${jwt}`
        }
      })).data;
      if (user.shopId) {//ショップの権限の場合は自店舗のみ
        const shop = shopData.find(x => x.shop_id === user.shopId);
        setShopMaster([shop]);
        con.shop = { value: shop.shop_id, label: shop.shop_name }
      } else {
        setShopMaster(shopData);
      }
      setCondition(con)
      setLockData(false);
      setHistorySearch(cardId ? true : false);
    }
  }, [setting, siteId, cardId, user]);

  const closeAlertModal = () => {
    setIsAlertModalOpen(false);
  };

  const refreshHistory = useCallback(async () => {
    if (historySearch) {
      try {
        const searchdate_start_date = condition.searchdate_start ? moment(condition.searchdate_start) : null
        const searchdate_end_date = condition.searchdate_end ? moment(condition.searchdate_end) : null
        if (!condition.searchdate_start || !condition.searchdate_end) {
          setAlertModalMessage("検索条件の購入日は必ず指定してください");
          setIsAlertModalOpen(true);
          throw new Error("")
        }
        var incubeShop = false;
        if (condition.shop && shopMaster) {
          const shop = shopMaster.find(x => x.shop_id === condition.shop.value);
          if (shop && shop.incubetenjin_flag === 1) {
            incubeShop = true;
          }
        }
        if (!condition.card_id && !incubeShop && searchdate_end_date.diff(searchdate_start_date, 'days') > 31) {
          setAlertModalMessage("お客様No未設定での購入日の指定期間は1ヶ月以内を指定してください");
          setIsAlertModalOpen(true);
          throw new Error("")
        }
        setLockData(true);
        const jwt = localStorage.getItem('jwt');
        var reg_params = {
          ...condition,
          site_id: siteId,
          mall_id: user.mallId,
          shop_id: condition.shop && condition.shop.value ? condition.shop.value : null,
          searchdate_start: condition.searchdate_start ? moment(condition.searchdate_start).format('YYYY-MM-DD 00:00:00') : null,
          searchdate_end: condition.searchdate_end ? moment(condition.searchdate_end).format('YYYY-MM-DD 23:59:59') : null
        }
        // ポイントデータ取得
        const data = (await axios.post(`${process.env.REACT_APP_BACKEND_URL}/points/backyard/history`, reg_params, {
          headers: {
            Authorization: `Bearer ${jwt}`
          }
        })).data;
        if (data.result) {
          if (sectionCondition.point_type && sectionCondition.point_type.value) {
            data.data = data.data.filter(item => {
              if (sectionCondition.point_type.value === 'COUPON') {
                return item.remarks && item.ticket_type !== constClass.FLAG.ON;
              } else if (sectionCondition.point_type.value === 'POINT') {
                return item.remarks && item.ticket_type === constClass.FLAG.ON;
              } else {
                return item.point_type === Number(sectionCondition.point_type.value);
              }
            });
          }
          const sum_point = data.data.reduce((prev, s) => prev + (Number(s.point) || 0), 0);
          const sum_point_mall = data.data.reduce((prev, s) => prev + (Number(s.point_mall) || 0), 0);
          const sum_point_shop = data.data.reduce((prev, s) => prev + (Number(s.point_shop) || 0), 0);
          const sum_use_point = data.data.reduce((prev, s) => prev + (Number(s.use_point) || 0), 0);
          const sum_used_point_mall = data.data.reduce((prev, s) => prev + (Number(s.use_point_mall) || 0), 0);
          const sum_used_point_shop = data.data.reduce((prev, s) => prev + (Number(s.use_point_shop) || 0), 0);

          setHistoryData(data.data.filter(item => item.point >= 0));
          setCondition({ ...condition, searchdate_start: moment(data.searchdate_start).toDate(), searchdate_end: moment(data.searchdate_end).toDate() });
          if (sectionCondition.point_type && sectionCondition.point_type.value) {
            setHistoryDataCount(data.data.length || 0);
          } else {
            setHistoryDataCount(data.count || 0);
          }
          setTotalPointsAwarded(sum_point || 0);
          setTotalPointsMallAwarded(sum_point_mall || 0);
          setTotalPointsShopAwarded(sum_point_shop || 0);
          setPointsUsed(sum_use_point || 0);
          setPointsMallUsed(sum_used_point_mall || 0);
          setPointsShopUsed(sum_used_point_shop || 0);
        } else {
          setAlertModalMessage("検索に失敗しました")
          setIsAlertModalOpen(true);
        }
      } catch (error) {
        console.log(error);
      } finally {
        setLockData(false);
        setHistorySearch(false);
      }
    }
  }, [condition, siteId, user.mallId, historySearch, sectionCondition, shopMaster]);

  const registerCancel = async () => {
    try {
      if (!cancelData || !cancelData.site_id) return;
      setLockData(true);
      const jwt = localStorage.getItem('jwt');
      var res = null;
      if (cancelData.point_date && cancelData.point > 0) {//ポイント付与取消
        const reg_params = {
          site_id: cancelData.site_id,
          customer_id: cancelData.customer_id,
          point_date: cancelData.point_date,
          upd_date: cancelData.upd_date,
          invalid_cause: invalidCause.value,
          upd_name: user.userId,
          mall_id: user.mallId,
          shop_id: user.shopId,
          cashier_no: user.cashierNo,
        }
        res = (await axios.post(`${process.env.REACT_APP_BACKEND_URL}/points/backyard/invalid`, reg_params, {
          headers: {
            Authorization: `Bearer ${jwt}`
          }
        }));
      }
      if (cancelData.ticket_id && cancelData.ticket_times) {//チケット利用取消
        const reg_params = {
          site_id: cancelData.site_id,
          ticket_id: cancelData.ticket_id,
          customer_id: cancelData.customer_id,
          ticket_month: cancelData.ticket_month,
          ticket_times: cancelData.ticket_times,
          upd_date: cancelData.upd_date,
          invalid_cause: invalidCause.value,
          upd_name: user.userId,
          mall_id: user.mallId,
          shop_id: user.shopId,
          cashier_no: user.cashierNo,
        }
        res = (await axios.post(`${process.env.REACT_APP_BACKEND_URL}/ticket/${cancelData.site_id}/${cancelData.ticket_id}/invalid`, reg_params, {
          headers: {
            Authorization: `Bearer ${jwt}`
          }
        }));
      }
      setCancelData(null);
      setModalFlag(false);
      if (res && res.data.msg) {
        //異常終了
        addToast(res.data.msg, { appearance: 'error', autoDismiss: true });
      } else {
        //正常終了
        addToast(`取消完了しました。`, { appearance: 'success', autoDismiss: true });
        //await refreshHistory();
        setHistorySearch(true);
        setInvalidCause({ value: constClass.INVALID_CAUSE.RETURNED, label: constClass.INVALID_CAUSE_NAME.RETURNED });
      }

    } catch (error) {

    } finally {
      setLockData(false);
    }
  }
  const handleCancelClick = async (data) => {
    setCancelData(data);
    setModalFlag(true);
  }

  const handleBackClick = () => {
    history.push(`${generatePath(`${props.match.path}`, { siteId: props.match.params.siteId, mallId: props.match.params.mallId })}pointterminal/${cardId || ""}`);
  }

  const renderCancelButton = (idx, data) => {
    return (
      <button key={idx}
        className={`btn btn-primary text-nowrap text-center`}
        disabled={lockData || data.invalid_flag === constClass.FLAG.ON}
        onClick={() => handleCancelClick(data)}>
        取消{data.invalid_flag === constClass.FLAG.ON && "済"}
      </button>
    )
  }
  const setConditionValue = (value, name) => {
    setHistoryData(null)
    if (name === "searchdate_start") {//検索開始日を設定する場合は終了日も同時に設定する 
      setCondition({ ...condition, [name]: value, "searchdate_end": value });
    } else {
      setCondition({ ...condition, [name]: value });
    }
  }
  const setConditionSectionValue = (value, name) => {
    setHistoryData(null)
    setSectionCondition({ ...condition, [name]: value });
  }
  useEffect(() => {
    refreshHistory()
  }, [refreshHistory]);

  useEffect(() => {
    refreshMaster();
  }, [refreshMaster]);

  return (
    <React.Fragment>
      <div className="containerfluid">
        <UseAlertModal isOpen={isAlertModalOpen} message={alertModalMessage} onClose={closeAlertModal} />
        {Common.getFunctionEnabled(setting, 'MEMBERCARD') && setting['MEMBER_CARD_CODE_TYPE'] === '2' && user.userClass === constClass.USER_CLASS.STAFF && (
          <div className="row col-12 mt-2">
            <div className='col-2'>
              <button type="button"
                className={`btn btn-secondary mx-1 w-100 text-nowrap`}
                onClick={() => { handleBackClick() }}>
                戻る
              </button>
            </div>
          </div>)}
        <div className="row mx-0 my-2 px-1-env">
          <div className="col-12">
            <div className="row my-1">
              <div className="col-2 pt-1 pr-0 text-center align-self-center">
                <span>お客様No</span>
              </div>
              <div className="col-4 pt-1 text-center">
                <input className={`form-control`} type="text" id={'card_id'} name={'card_id'} disabled={cardId} value={condition.card_id || ""} onChange={(e) => setConditionValue(e.target.value, "card_id")}></input>
              </div>
              <div className="col-2 pt-1 pr-0 pl-1 text-center align-self-center">
                <span>店舗</span>
              </div>
              <div className="col-4 pt-1 text-center">
                <Select
                  styles={{ container: (base) => ({ ...base, zIndex: 600 }) }}
                  options={shopMaster ? shopMaster.map(s => ({ value: s.shop_id, label: `${s.shop_name}` })) : []}
                  isClearable={true}
                  closeMenuOnSelect={true}
                  value={condition.shop ? condition.shop : {}}
                  isDisabled={(shopMaster && shopMaster.length === 1) ? true : false}
                  onChange={(value) => setConditionValue(value, "shop")} />
              </div>
              <div className="col-2 pt-1 pr-0 pl-1 text-center align-self-center">
                <span>購入日</span>
              </div>
              <div className="col-10 pt-1 text-center">
                <div className='row'>
                  <div className="col-5 text-center">
                    <DatePicker className="custom-select text-left"
                      locale="ja" dateFormat="yyyy/MM/dd" monthsShown="1" id={'searchdate_start'} name={'searchdate_start'}
                      popperPlacement='bottom'
                      selected={condition.searchdate_start}
                      maxDate={new Date()}
                      // maxDate={condition.searchdate_end ? condition.searchdate_end : new Date()}
                      onChange={(value) => setConditionValue(value, "searchdate_start")}
                      placeholderText="- 選択 -"
                      autoComplete='off'
                      onFocus={(e) => e.target.blur()}
                    />
                  </div>
                  {condition.shop && shopMaster && shopMaster.find(x => x.shop_id === condition.shop.value) && shopMaster.find(x => x.shop_id === condition.shop.value).incubetenjin_flag === constClass.FLAG.ON &&
                    <React.Fragment>
                      <span>～</span>
                      <div className="col-5 text-center">
                        <DatePicker className="custom-select text-left"
                      locale="ja" dateFormat="yyyy/MM/dd" monthsShown="1" id={'searchdate_end'} name={'searchdate_end'}
                      popperPlacement='bottom'
                      selected={condition.searchdate_end}
                      minDate={condition.searchdate_start ? condition.searchdate_start : null}
                      maxDate={new Date()}
                      onChange={(value) => setConditionValue(value, "searchdate_end")}
                      placeholderText="- 選択 -"
                      autoComplete='off'
                      onFocus={(e) => e.target.blur()}
                    />
                      </div>
                    </React.Fragment>
                  }
                  {/*<div className="col-2 text-center">～</div>
                  <div className="col-5 text-center">
                    <DatePicker className="custom-select text-left"
                      locale="ja" dateFormat="yyyy/MM/dd" monthsShown="1" id={'searchdate_end'} name={'searchdate_end'}
                      popperPlacement='bottom'
                      selected={condition.searchdate_end}
                      minDate={condition.searchdate_start ? condition.searchdate_start : null}
                      maxDate={new Date()}
                      onChange={(value) => setConditionValue(value, "searchdate_end")}
                      placeholderText="- 選択 -"
                      autoComplete='off'
                      onFocus={(e) => e.target.blur()}
                    />
                  </div>*/}
                </div>
              </div>
              <div className="col-2 pt-1 pr-0 pl-1 text-center align-self-center">
                <span>区分</span>
              </div>
              <div className="col-3 pt-1 text-center">
                <Select
                  styles={{ container: (base) => ({ ...base, zIndex: 600 }) }}
                  // options={shopMaster ? shopMaster.map(s => ({ value: s.shop_id, label: `${s.shop_name}` })) : []}
                  options={[
                    ...Object.keys(constClass.POINT_TYPE).map(key => ({
                      value: constClass.POINT_TYPE[key],
                      label: constClass.POINT_TYPE_NAME[constClass.POINT_TYPE[key]]
                    })),
                    { value: 'COUPON', label: 'クーポン利用' },
                    { value: 'POINT', label: 'ポイント利用' }
                  ]}
                  isClearable={true}
                  closeMenuOnSelect={true}
                  value={sectionCondition.point_type ? sectionCondition.point_type : {}}
                  onChange={(value) => setConditionSectionValue(value, "point_type")}
                />
              </div>
              <div className="col-3 pt-1 text-center pt-1 pr-0 text-center align-self-center">
                <div className='row'>
                  <div className="col-autp text-right">
                    <input className={`form-control`} style={{ width: "2rem" }} type="checkbox" id={'invalidFlag'} name={'invalidFlag'} value={constClass.FLAG.ON} checked={condition.invalid_flag === constClass.FLAG.ON} onChange={(e) => setConditionValue(condition.invalid_flag === constClass.FLAG.ON ? constClass.FLAG.OFF : constClass.FLAG.ON, "invalid_flag")}></input>
                  </div>
                  <div className="col-6 pt-2 text-left align-middle text-nowrap">
                    <label htmlFor="invalidFlag">取消したデータを含める</label>
                  </div>
                </div>
              </div>
              <div className='col-0.5'></div>
              <div className="col-2 text-center align-bottom mt-2">
                <button type="button"
                  className={`btn btn-primary mx-1 w-100 text-nowrap`}
                  disabled={lockData}
                  onClick={() => setHistorySearch(true)}>
                  検索</button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="container">
        {(historyData !== null) && (
          <div className="print-list">
            <div className="row mb-0  ">
              <div className="col-2 mx-0 align-self-center text-right border h-100">
                <div className="row px-0">
                  <div className="col-auto py-1 px-2 bg-lightwhite h-100">一覧表件数</div>
                  <div className="col py-1">{historyDataCount.toLocaleString()}</div>
                </div>
              </div>
              <div className="col-5 mx-0 align-self-center text-right border h-100">
                <div className="row px-0">
                  <div className="col-auto py-1 px-2 bg-lightwhite h-100">合計ポイント付与数</div>
                  <div className="col py-1">
                    {totalPointsAwarded.toLocaleString()}<span>（施設: {totalPointsMallAwarded.toLocaleString()} / 店舗: {totalPointsShopAwarded.toLocaleString()}）</span>
                  </div>
                </div>
              </div>
              <div className="col-5 mx-0 align-self-center text-right border h-100">
                <div className="row px-0">
                  <div className="col-auto py-1 px-2 bg-lightwhite h-100">ポイント利用数</div>
                  <div className="col py-1">
                    {pointsUsed.toLocaleString()}<span>（施設: {pointsMallUsed.toLocaleString()} / 店舗: {pointsShopUsed.toLocaleString()}）</span>
                  </div>
                </div>
              </div>
            </div>
            <div className="row mb-3 p-0">
              <div className="col-12 p-0">
                <InfiniteScroll
                  loadMore={(p) => setPage(Number(p) * pageCount)}    //項目を読み込む際に処理するコールバック関数 
                  hasMore={(historyData.length > page)}         //読み込みを行うかどうかの判定
                  loader={<div key={-1}>{historyData.length}件中 {page + pageCount}件まで表示中（スクロールで読み込み）</div>}       //読み込み最中に表示する項目
                >
                  <table className="table table-bordered table-striped" height="1">
                    <thead className={`table-info`}>
                      <tr>
                        <th className="text-center align-middle text-nowrap">
                          お客様No
                        </th>
                        <th className="text-center align-middle text-nowrap">
                          購入日
                        </th>
                        <th className="text-center align-middle text-nowrap">
                          区分
                        </th>
                        <th className="text-center align-middle text-nowrap">
                          名称
                        </th>
                        <th className="text-center align-middle text-nowrap">
                          ポイント数
                        </th>
                        <th className="text-center align-middle text-nowrap">
                          金額
                        </th>
                        {!condition.shop && <th className="text-center align-middle text-nowrap">
                          店舗
                        </th>}
                        <th className="text-center align-middle">
                          処理
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {historyData && historyData.length === 0 && <tr><td colSpan={8} className='text-center'>対象データなし</td></tr>}
                      {historyData.map((data, idx) => (idx < (page + pageCount) &&
                        <tr key={idx}>
                          {/* お客様No */}
                          <td className="text-center align-middle p-1">
                            {cardId ? data.card_id :
                              <button className='btn btn-link' onClick={e => setConditionValue(data.card_id, "card_id")}>{data.card_id || ''}</button>}
                          </td>
                          {/* ポイント日時 */}
                          <td className="text-center align-middle p-1">
                            {moment(data.history_date).format('YYYY/MM/DD HH:mm')}
                          </td>
                          {/* 区分 */}
                          <td className="text-center align-middle p-1">
                            {data.invalid_flag !== constClass.FLAG.ON ?
                              data.remarks && data.ticket_type !== constClass.FLAG.ON ? "クーポン利用" :
                                data.remarks && data.ticket_type === constClass.FLAG.ON ? "ポイント利用" :
                                  constClass.POINT_TYPE_NAME[data.point_type] :
                              <div className='small'>
                                取消済{(data.invalid_cause && data.invalid_cause in constClass.INVALID_CAUSE_NAME) && `(${constClass.INVALID_CAUSE_NAME[data.invalid_cause]})`}：
                                {data.invalid_date && moment(data.invalid_date).format('YYYY/MM/DD HH:mm')}
                              </div>
                            }
                          </td>
                          {/* 名称 */}
                          <td className="text-center align-middle p-1">
                            {data.remarks ? data.remarks : ""}
                          </td>
                          {/* ポイント数 */}
                          <td className="text-right align-middle p-1">
                            {data.use_point ? `▲ ${data.use_point.toLocaleString()} pt` : data.point ? `${data.point.toLocaleString()} pt` : "-"}
                          </td>
                          {/* 金額 */}
                          <td className="text-right align-middle p-1">
                            {data.amount ? `${data.amount.toLocaleString()} 円` : "-"}
                          </td>
                          {/* 店舗 */}
                          {!condition.shop && <td className="text-center align-middle p-1">
                            {data.shop_name ? data.shop_name : (data.shop_id && shopMaster ? shopMaster.findIndex(x => x.shop_id === data.shop_id) >= 0 ? shopMaster.find(x => x.shop_id === data.shop_id).shop_name : "" : "")}
                          </td>}
                          {/* 処理 */}
                          <td className="text-center align-middle p-1">
                            {Number(data.point) > 0 ? renderCancelButton(idx, data) : "-"}
                          </td>
                        </tr>
                      ))
                      }
                    </tbody>
                  </table>
                </InfiniteScroll>
              </div>
            </div>
          </div>
        )}
        <Modal isOpen={modalFlag && cancelData !== null} style={modalStyle} onRequestClose={() => setModalFlag(false)}>
          {(cancelData !== null) &&
            <div className='m-5'>
              <div className='row'>
                <div className='col-12 h4 text-center'>下記の{cancelData.use_point ? "ポイント利用" : "ポイント付与"}を取消します。</div>
                <div className='col-12 text-center text-danger'>※取消処理は元に戻すことができません。ご注意ください※</div>
              </div>
              <div className='row py-2 px-3'>
                <div className='col-4 text-right px-3'>日付</div>
                <div className='col-4'>{moment(cancelData.history_date).format('YYYY/MM/DD HH:mm')}</div>
              </div>
              <div className='row py-2 px-3'>
                <div className='col-4 text-right px-3'>お客様カード番号</div>
                <div className='col-4'>{cancelData.card_id || ''}</div>
              </div>
              <div className='row py-2 px-3'>
                <div className='col-4 text-right px-3'>ポイント数</div>
                <div className='col-4 text-right'>{cancelData.use_point ? `▲ ${cancelData.use_point.toLocaleString()} pt` : cancelData.point ? `${cancelData.point.toLocaleString()} pt` : ""}</div>
              </div>
              <div className='row py-2 px-3'>
                <div className='col-4 text-right px-3'>金額</div>
                <div className='col-4 text-right'>{cancelData.amount ? `${cancelData.amount.toLocaleString()} 円` : ""}</div>
              </div>
              <div className='row py-2 px-3'>
                <div className='col-4 text-right px-3'>内容</div>
                <div className='col-4 text-right'>{cancelData.remarks || ""}</div>
              </div>
              <div className='row py-2 px-3'>
                <div className='col-4 text-right px-3'>取消理由</div>
                <div className="col-4 text-center">
                  <Select
                    styles={{ container: (base) => ({ ...base, zIndex: 600 }) }}
                    options={(Object.values(constClass.INVALID_CAUSE)).map(s => ({ value: s, label: constClass.INVALID_CAUSE_NAME[s] }))}
                    isClearable={true}
                    closeMenuOnSelect={true}
                    value={invalidCause}
                    onChange={(value) => setInvalidCause(value)} />
                </div>
              </div>
              <div className='row py-2'>
                <div className='col text-center'>
                  <button className='btn btn-danger text-nowrap' disabled={invalidCause === null || lockData} onClick={() => registerCancel()}>取り消しを確定</button>
                </div>
                <div className='col text-center'>
                  <button className='btn btn-secondary text-nowrap' disabled={lockData} onClick={() => setModalFlag(false)}>戻る</button>
                </div>
              </div>
            </div>
          }
        </Modal>
      </div>
    </React.Fragment>
  )
}

export default PointHistory;